module.exports = __webpack_public_path__ + "static/img/env14.1980cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env14.png
// module id = 107
// module chunks = 4